import React, { useState } from 'react';
import ConfigManagement from './components/ConfigManagement';
import IpWhitelist from './components/IpWhitelist';
import Header from './components/Header';
import { useApp } from './contexts/AppContext';
import { t } from './utils/translations';
import './App.css';

const App: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'config' | 'ip'>('config');
  const { language } = useApp();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <Header />
      
      {/* 主要內容區域 */}
      <main className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 md:py-8">
        {/* 標籤導航 */}
        <div className="mb-6 md:mb-8">
          <nav className="flex space-x-1 bg-gray-100 dark:bg-gray-800 p-1 rounded-xl overflow-hidden">
            <button
              onClick={() => setActiveTab('config')}
              className={`flex-1 flex items-center justify-center px-3 py-2.5 sm:px-6 sm:py-3 text-xs sm:text-sm font-medium rounded-lg transition-all duration-200 ${
                activeTab === 'config'
                  ? 'bg-white dark:bg-gray-700 text-blue-600 dark:text-blue-400 shadow-sm'
                  : 'text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200'
              }`}
            >
              <svg className="w-4 h-4 sm:w-5 sm:h-5 mr-1 sm:mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              <span className="truncate">{t('configManagement', language)}</span>
            </button>
            <button
              onClick={() => setActiveTab('ip')}
              className={`flex-1 flex items-center justify-center px-3 py-2.5 sm:px-6 sm:py-3 text-xs sm:text-sm font-medium rounded-lg transition-all duration-200 ${
                activeTab === 'ip'
                  ? 'bg-white dark:bg-gray-700 text-blue-600 dark:text-blue-400 shadow-sm'
                  : 'text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200'
              }`}
            >
              <svg className="w-4 h-4 sm:w-5 sm:h-5 mr-1 sm:mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
              </svg>
              <span className="truncate">{t('ipWhitelist', language)}</span>
            </button>
          </nav>
        </div>

        {/* 內容區域 */}
        <div className="fade-in">
          <div className="bg-white dark:bg-gray-800 rounded-xl md:rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 overflow-hidden">
            <div className="p-4 sm:p-6 md:p-8">
              {activeTab === 'config' ? <ConfigManagement /> : <IpWhitelist />}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default App;
